<span *ngIf="text" (click)="tooltip.toggle()">
    <mat-icon #tooltip="matTooltip" [matTooltip]="text">help</mat-icon>
</span>
